import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

interface FormErrorProps {
  errorText: string;
  errorParameters?: Record<string, string | number>;
  extraClassNames?: string;
  dataTestId?: string;
}

export const FormError: React.FunctionComponent<FormErrorProps> = (props) => {
  const { errorText, errorParameters, extraClassNames, dataTestId } = props;
  const { t } = useTranslation();

  return (
    <div className={clsx('sq-text-danger mt5', extraClassNames)} data-testid={dataTestId}>
      {errorParameters ? t(errorText, errorParameters) : t(errorText)}
    </div>
  );
};
